export default __webpack_public_path__ + "static/media/NCIndonesia.d08e9dcb.png";